import { Icon } from '@/components/common/Icon';
import { useTranslation } from 'react-i18next';
import type { OwnerPet } from '@/api/patients/patientsApi.types';
import { Card } from '@/components/ui/card';
import { LoadingSpinner } from '@/components/common/LoadingSpinner';
import { PetCard } from '../PetCard';

interface YourPetsCardProps {
  pets: OwnerPet[];
  isLoading: boolean;
}

export function YourPetsCard({ pets, isLoading }: YourPetsCardProps) {
  const { t } = useTranslation('clients');

  return (
    <Card as="section">
      <div className="flex items-center gap-2 mb-3">
        <span className="w-9 h-9 rounded-xl bg-zoovpalelavender text-zooviolet flex items-center justify-center shrink-0">
          <Icon name="PawPrint" />
        </span>
        <h2 className="text-sm font-bold text-zooindigo">{t('portal.yourPets')}</h2>
      </div>
      {isLoading === true ? (
        <div className="py-6 flex justify-center">
          <LoadingSpinner className="w-6 h-6" />
        </div>
      ) : pets.length === 0 ? (
        <p className="text-sm text-zoomuted py-2">{t('portal.noPets')}</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {pets.map(function renderPet(pet) {
            return <PetCard key={pet.id} pet={pet} />;
          })}
        </div>
      )}
    </Card>
  );
}
